// ============================================
// FILE: src/data/properties.js
// ============================================

/*
  ─── HOW TO ADD YOUR OWN PHOTOS ───

  Each property has:
    image:  the single cover photo shown on the listing card
    images: an array of ALL photos shown on the property's detail page
            (cover + hall + living room + bedroom + kitchen + bathroom, etc.)
            Add as many as you want — the gallery adapts automatically.

  You can point `image` / `images` at:

  1) A hosted URL (easiest — just paste the link):
       image: "https://yourcdn.com/property-1/cover.jpg"

  2) A file in your public/ folder:
       - put the file at:  public/images/property-1/cover.jpg
       - reference it as:  image: "/images/property-1/cover.jpg"

  3) A local file you import (Vite/CRA bundles it for you):
       import cover1 from '../assets/property-1/cover.jpg';
       import hall1   from '../assets/property-1/hall.jpg';
       ...then use:  image: cover1,  images: [cover1, hall1, ...]

  Just replace the placeholder URLs below with your own — everything else
  (card, gallery, detail page) will pick them up automatically.
*/

export const properties = [
  {
  id: 1,
  title: "1 BHK Apartment",
  location: "Nyati Era, Dhanori ,Pune",
  price: "₹18,000/mo",
  area: "396 sqft",
  type: "Rent",
     featured: true,
  bedrooms: 1,
  bathrooms: 1,
  furnishing: "Semi Furnished",
  floor: "N/A",
  facing: "N/A",
  parking: "N/A",
  possession: "Immediate",
  description: "A well-maintained 1 BHK semi furnished apartment in Nyati Era, Dhanori. Ideal for families, working professionals, or couples with immediate possession available. All tenants are allowed.",
  amenities: [
    "Bed",
    "Wardrobe",
    "Kitchen Trolley",
    "5 Seater Sofa",
    "Lift",
    "Security",
    "24x7 Water Supply",
    "All Allowed"
  ],
  deposit: "₹50,000",
  image: "/images/property1/hall1.jpeg",
  images: [
    "/images/property1/hall.jpeg",
    "/images/property1/balcony.jpeg",
    "/images/property1/kitchen.jpeg",
    "/images/property1/bathroom.jpeg",
    "/images/property1/hall1.jpeg",
    "/images/property1/corner.jpeg"
  ]
},


{
  id: 53,
  title: "2 BHK Apartment",
  location: "Park Springs, Porwal Road, Lohegaon, Pune",
  price: "₹75 Lacs",
  area: "762 sqft",
  type: "Sale",
  featured: true,
  bedrooms: 2,
  bathrooms: 2,
  furnishing: "Semi Furnished",
  floor: "3rd Floor (Out of 8)",
  facing: "N/A",
  parking: "Covered Parking",
  possession: "Immediate",
  description:
    "A spacious 2 BHK semi furnished apartment located in Park Springs, Porwal Road, Lohegaon. Situated on the 3rd floor of an 8-storey building with covered parking. Ideal for families looking for a ready-to-move-in home in a well-connected location.",
  amenities: [
    "Covered Parking",
    "Lift",
    "24x7 Security",
    "Power Backup",
    "Children's Play Area",
    "Landscaped Garden",
    "Club House",
    "Water Supply"
  ],
  deposit: "N/A",
  image: "/images/property3/img1.jpeg",
  images: [
    "/images/property3/img2.jpeg",
    "/images/property3/img3.jpeg",
    "/images/property3/img4.jpeg",
    "/images/property3/img5.jpeg",
    "/images/property3/img6.jpeg",
    "/images/property3/img7.jpeg",
    "/images/property3/img8.jpeg"
  ]
},


{
  id: 54,
  title: "1 BHK Apartment",
  location: "Long Island, Pride World City, Charholi, Pune",
  price: "₹42 Lacs",
  rent: "₹18,500/mo",
  area: "510 sqft",
  type: "Sale",
  featured: true,
  bedrooms: 1,
  bathrooms: 1,
  furnishing: "Semi Furnished",
  floor: "5th Floor (Out of 12)",
  facing: "N/A",
  parking: "Open Reserved Parking",
  possession: "Immediate",
  description:
    "A well-maintained 1 BHK semi furnished apartment in Long Island, Pride World City. Suitable for both sale and rent, offering excellent connectivity, modern amenities, and a comfortable lifestyle. Located on the 5th floor of a 12-storey building with reserved open parking.",
  amenities: [
    "Lift",
    "24x7 Security",
    "Open Reserved Parking",
    "Power Backup",
    "Children's Play Area",
    "Club House",
    "Landscaped Garden",
    "24x7 Water Supply"
  ],
  deposit: "₹40,000",
  image: "/images/property4/img1.jpeg",
  images: [
    "/images/property4/img1.jpeg",
    "/images/property4/img2.jpeg",
    "/images/property4/img3.jpeg",
    "/images/property4/img4.jpeg",
    "/images/property4/img5.jpeg",
    "/images/property4/img6.jpeg",
    "/images/property4/img2.jpeg"
  ]
},


{
  id: 55,
  title: "1 BHK Apartment",
  location: "Long Island, Pride World City, Charholi, Pune",
  price: "₹18,500/mo",
  rent: "₹18,500/mo",
  area: "510 sqft",
  type: "Rent",
  featured: true,
  bedrooms: 1,
  bathrooms: 1,
  furnishing: "Semi Furnished",
  floor: "5th Floor (Out of 12)",
  facing: "N/A",
  parking: "Open Reserved Parking",
  possession: "Immediate",
  description:
    "A well-maintained 1 BHK semi furnished apartment in Long Island, Pride World City. Suitable for both sale and rent, offering excellent connectivity, modern amenities, and a comfortable lifestyle. Located on the 5th floor of a 12-storey building with reserved open parking.",
  amenities: [
    "Lift",
    "24x7 Security",
    "Open Reserved Parking",
    "Power Backup",
    "Children's Play Area",
    "Club House",
    "Landscaped Garden",
    "24x7 Water Supply"
  ],
  deposit: "₹40,000",
  image: "/images/property4/img2.jpeg",
  images: [
    "/images/property4/img1.jpeg",
    "/images/property4/img2.jpeg",
    "/images/property4/img3.jpeg",
    "/images/property4/img4.jpeg",
    "/images/property4/img5.jpeg",
    "/images/property4/img6.jpeg",
    "/images/property4/img3.jpeg"
  ]
},
{
  id: 56,
  title: "2 BHK Apartment",
  location: "Gulmohar Sky Park, Dhanori, Pune",
  price: "₹24,000/mo",
  rent: "₹24,000/mo",
  area: "780 sqft",
  type: "Rent",
  featured: true,
  bedrooms: 2,
  bathrooms: 2,
  furnishing: "Semi Furnished",
  floor: "N/A",
  facing: "N/A",
  parking: "Reserved Parking",
  possession: "Immediate",
  description:
    "A spacious 2 BHK semi furnished apartment in Gulmohar Sky Park, Dhanori. Featuring a modular kitchen, this home is ideal for families and working professionals. The apartment offers modern amenities, excellent connectivity, and a comfortable lifestyle with immediate possession.",
  amenities: [
    "Modular Kitchen",
    "Lift",
    "24x7 Security",
    "Reserved Parking",
    "Power Backup",
    "Children's Play Area",
    "Club House",
    "Landscaped Garden",
    "24x7 Water Supply"
  ],
  deposit: "₹50,000",
  image: "/images/property5/img1.jpeg",
  images: [
    "/images/property5/img1.jpeg",
    "/images/property5/img2.jpeg",
    "/images/property5/img3.jpeg",
    "/images/property5/img4.jpeg",
    "/images/property5/img2.jpeg",
    "/images/property5/img6.jpeg"
  ]
},

{
  id: 57,
  title: "3 BHK Apartment",
  location: "Amorapolis, Dhanori",
  price: "₹45,000/mo",
  area: "N/A",
  type: "Rent",
  bedrooms: 3,
  featured: true,
  bathrooms: 3,
  furnishing: "Furnished",
  floor: "N/A",
  facing: "N/A",
  parking: "N/A",
  possession: "Ready to Move",
  description: "A spacious 3 BHK fully furnished apartment in Amorapolis. Available for rent with all tenants allowed, making it suitable for families, working professionals, and other tenants.",
  amenities: [
    "Lift",
    "Security",
    "24x7 Water Supply",
    "Furnished",
    "Ready to Move",
    "All Tenants Allowed"
  ],
  deposit: "₹1.35 Lacs",
  image: "/images/property6/hall.jpeg",
  images: [
    "/images/property6/hall.jpeg",
    "/images/property6/bedroom.jpeg",
    "/images/property6/kitchen.jpeg",
    "/images/property6/balcony.jpeg",
       "/images/property6/bathroom.jpeg",
          "/images/property6/free_space.jpeg"
  ]
},

{
  id: 58,
  title: "2 BHK Apartment",
  location: "Pride World City Manhattan, Dhanori",
  price: "₹73 Lacs",
  area: "725 sq.ft",
  type: "Sale",
  bedrooms: 2,
  featured: true,
  bathrooms: 2,
  furnishing: "N/A",
  floor: "12 out of 20",
  facing: "N/A",
  parking: "N/A",
  possession: "Ready to Move",
  description: "A 2 BHK apartment available for sale in Pride World City Manhattan with a carpet area of 725 sq.ft. Located on the 12th floor of a 20-storey building. The property is also available for rent.",
  amenities: [
    "Lift",
    "Security",
    "24x7 Water Supply",
    "Ready to Move",
    "Carpet Area 725 sq.ft",
    "Also Available for Rent"
  ],
  deposit: "₹52,000",
  rent: "₹26,000/mo",
  image: "/images/property7/bedroom.jpeg",
  images: [
    
    "/images/property7/bedroom2.jpeg",
"/images/property7/balcony2.jpeg",
    "/images/property7/kitchen.jpeg",
    "/images/property7/bathroom.jpeg",
    "/images/property7/bedroom2.jpeg",
    "/images/property7/balcony.jpeg",
  ]
},


{
  id: 2,
  title: "2 BHK Apartment",
  location: "Shriram Nysa, Dhanori",
  price: "₹22,000/mo",
  area: "N/A",
  type: "Rent",
  bedrooms: 2,
     featured: true,
  bathrooms: 2,
  furnishing: "Unfurnished",
  floor: "N/A",
  facing: "N/A",
  parking: "N/A",
  possession: "Ready to Move",
  description: "A spacious 2 BHK unfurnished apartment in Shriram Nysa, Dhanori. Ready to move property suitable for vegetarian families looking for a comfortable residential space.",
  amenities: [
    "Lift",
    "Security",
    "24x7 Water Supply",
    "Ready to Move",
    "Vegetarian Family Preferred"
  ],
  deposit: "₹50,000",
  image: "/images/property2/balcony.jpeg",
  images: [
    "/images/property2/hall.jpeg",
    "/images/property2/bathroom.jpeg",
    "/images/property2/kitche.jpeg",
    "/images/property2/balcony.jpeg",
   
  ]
}
,


 {
  id: 50,
  title: "1.5 BHK Apartment",
  location: "Atlantic Pride World City",
  price: "₹25K / Month",
  area: "584 sqft Carpet",
  type: "Rent",
  bedrooms: 1.5,
  bathrooms: 1,
  furnishing: "Semi-Furnished",
  floor: "—",
  facing: "—",
  parking: "1 Covered",
  possession: "Ready to Move",
  rent: "₹25,000",
  deposit: "₹60,000",
  description: "Well-planned 1.5 BHK apartment in Atlantic Pride World City with 584 sqft carpet area, 1 covered parking space, and convenient residential amenities. Ideal for comfortable family living.",
  amenities: [
    "1 Covered Parking",
    "24x7 Security",
    "Power Backup",
    "Lift",
    "Clubhouse",
    "Children's Play Area"
  ],
  image: "/images/property9/bedroom.jpeg",
  images: [
    "/images/property9/hall.jpeg",
    "/images/property9/room.jpeg",
    "/images/property9/kitchen.jpeg",
    "/images/property9/bedroom.jpeg",
    "/images/property9/washroom.jpeg",
    "/images/property9/space.jpeg",
    
  ]
},

 {
  id: 51,
  title: "3 BHK Apartment",
  location: "Atlantic Pride World City",
  price: "₹1.80 Cr",
  area: "1460 sqft Carpet",
  type: "Sale",
  bedrooms: 3,
  bathrooms: 2,
  furnishing: "Semi-Furnished",
  floor: "16th of 23",
  facing: "—",
  parking: "—",
  possession: "Ready to Move",
  description: "Spacious 3 BHK apartment in Atlantic Pride World City with 1460 sqft carpet area, located on the 16th floor of a 23-storey building. An excellent choice for comfortable family living.",
  amenities: [
    "Swimming Pool",
    "Gym",
    "24x7 Security",
    "Power Backup",
    "Clubhouse",
    "Children's Play Area"
  ],
  image: "/images/property8/hall.jpeg",
  images: [
    "/images/property8/hall.jpeg",
    "/images/property8/kitchen.jpeg",
    "/images/property8/washroom.jpeg",
    "/images/property8/space.jpeg",
    "/images/property8/space1.jpeg",
    "/images/property8/balcony.jpeg"
  ]
},
  {
  id: 3,
  title: "2 BHK Apartment",
  location: "Longisland Pride World City",
  price: "₹25,000/mo",
  area: "780 sqft Carpet",
  type: "Rent",
  bedrooms: 2,
  bathrooms: 2,
  featured: true,
  furnishing: "—",
  floor: "8th of 12",
  facing: "—",
  parking: "1 Covered",
  possession: "Ready to Move",
  deposit: "₹60,000",
  description: "Well-planned 2 BHK apartment in Longisland Pride World City with 780 sqft carpet area, located on the 8th floor of a 12-storey building with 1 parking space.",
  amenities: [
    "1 Covered Parking",
    "24x7 Security",
    "Power Backup",
    "Lift",
    "Clubhouse",
    "Children's Play Area"
  ],
   image: "/images/property10/kitchen.jpeg",
  images: [
    "/images/property10/hall.jpeg",
    "/images/property10/entry.jpeg",
    "/images/property10/kitchen_balcony.jpeg",
    "/images/property10/washroom.jpeg",
    "/images/property10/balcony.jpeg",
    "/images/property10/space.jpeg"
  ]
},
 {
  id: 4,
  title: "2 BHK Apartment",
  location: "Longisland Pride World City",
  price: "₹69 Lacs",
  area: "780 sqft Carpet",
  type: "Sale",
  bedrooms: 2,
  bathrooms: 2,
  featured: true,
  furnishing: "—",
  floor: "8th of 12",
  facing: "—",
  parking: "1 Covered",
  possession: "Ready to Move",
  description: "Well-planned 2 BHK apartment in Longisland Pride World City with 780 sqft carpet area, located on the 8th floor of a 12-storey building with 1 parking space.",
  amenities: [
    "1 Covered Parking",
    "24x7 Security",
    "Power Backup",
    "Lift",
    "Clubhouse",
    "Children's Play Area"
  ],
  image: "/images/property10/kitchen.jpeg",
  images: [
    "/images/property10/hall.jpeg",
    "/images/property10/entry.jpeg",
    "/images/property10/kitchen_balcony.jpeg",
    "/images/property10/washroom.jpeg",
    "/images/property10/balcony.jpeg",
    "/images/property10/space.jpeg"
  ]
},
  {
    id: 5,
    title: "3BHK Luxurious Apartment",
    location: "Kalyani Nagar, Pune",
    price: "₹2.2 Cr",
    area: "1900 sqft",
    type: "Sale",
    bedrooms: 3,
    bathrooms: 3,
    featured: true,
    furnishing: "Semi-Furnished",
    floor: "16th of 20",
    facing: "East",
    parking: "2 Covered",
    possession: "Ready to Move",
    description: "A premium 3BHK in Kalyani Nagar with modern amenities and a serene view, ideal for luxury living.",
    amenities: ["Swimming Pool", "Clubhouse", "Gym", "Garden", "24x7 Security", "Power Backup"],
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1567016432779-094069958ea5?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615873968403-89e068629265?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 6,
    title: "4BHK Penthouse with Terrace",
    location: "Hinjewadi, Pune",
    price: "₹3.25 Cr",
    area: "2800 sqft",
    type: "Sale",
    bedrooms: 4,
    bathrooms: 3,
    furnishing: "Fully Furnished",
    floor: "18th (Top)",
    facing: "West",
    parking: "3 Covered",
    possession: "Immediate",
    description: "A sky-high penthouse in Hinjewadi with a private terrace and uninterrupted views — the kind of address that speaks for itself.",
    amenities: ["Private Terrace", "Infinity Pool", "Concierge", "Home Automation", "Valet Parking", "Gym"],
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1567016432779-094069958ea5?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615873968403-89e068629265?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 7,
    title: "Ready to Move 3BHK",
    location: "Wakad, Pune",
    price: "₹1.35 Cr",
    area: "1250 sqft",
    type: "Sale",
    bedrooms: 3,
    bathrooms: 2,
    furnishing: "Semi-Furnished",
    floor: "5th of 14",
    facing: "North",
    parking: "1 Covered",
    possession: "Ready to Move",
    description: "A well-planned 3BHK in a gated Wakad community with strong social infrastructure and quick access to the highway.",
    amenities: ["Clubhouse", "Garden", "Gym", "Kids Play Area", "24x7 Security", "Power Backup"],
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615873968403-89e068629265?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 8,
    title: "Weekend Villa with Garden",
    location: "Maval, Pune",
    price: "₹3.6 Cr",
    area: "3400 sqft",
    type: "Sale",
    bedrooms: 4,
    bathrooms: 3,
    furnishing: "Unfurnished",
    floor: "Ground + 1",
    facing: "East",
    parking: "3 Open",
    possession: "Ready to Move",
    description: "A hillside weekend villa in Maval surrounded by greenery, with a private garden made for slow mornings and long evenings.",
    amenities: ["Private Garden", "Mountain View", "Fireplace", "Outdoor Deck", "Borewell", "Caretaker Available"],
    image: "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1540518614846-7eded433c457?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 9,
    title: "Luxury 4BHK Penthouse",
    location: "Baner, Pune",
    price: "₹3.25 Cr",
    area: "2800 sqft",
    type: "Sale",
    bedrooms: 4,
    bathrooms: 4,
    featured: true,
    furnishing: "Semi-Furnished",
    floor: "18th (Top)",
    facing: "South",
    parking: "2 Covered",
    possession: "Ready to Move",
    description: "A Baner penthouse with double-height living space and a private sundeck, in one of Pune's fastest-growing corridors.",
    amenities: ["Sundeck", "Clubhouse", "Gym", "Infinity Pool", "24x7 Security", "Home Automation"],
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1631889992043-c9b829fc8b0c?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 10,
    title: "Spacious 3BHK Apartment",
    location: "Undri, Pune",
    price: "₹1.05 Cr",
    area: "1420 sqft",
    type: "Sale",
    bedrooms: 3,
    bathrooms: 2,
    furnishing: "Semi-Furnished",
    floor: "8th of 12",
    facing: "North-East",
    parking: "1 Covered",
    possession: "Ready to Move",
    description: "A spacious 3BHK in Undri with scenic views and easy access to schools, hospitals, and shopping malls.",
    amenities: ["Swimming Pool", "Gym", "Clubhouse", "24x7 Security", "Garden", "Power Backup"],
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 11,
    title: "Premium 3BHK Flat",
    location: "Kharadi, Pune",
    price: "₹1.35 Cr",
    area: "1380 sqft",
    type: "Sale",
    bedrooms: 3,
    bathrooms: 3,
    furnishing: "Semi-Furnished",
    floor: "10th of 20",
    facing: "North",
    parking: "2 Covered",
    possession: "Ready to Move",
    description: "A generously laid-out 3BHK in Kharadi's premium tech corridor, close to Eon IT Park and the riverside promenade.",
    amenities: ["Clubhouse", "Swimming Pool", "Gym", "Garden", "24x7 Security", "Power Backup"],
    image: "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600121848594-d8644e57abab?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1592229505726-ca121723b8ef?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 12,
    title: "Independent Bungalow",
    location: "Pashan, Pune",
    price: "₹4.8 Cr",
    area: "3600 sqft",
    type: "Sale",
    bedrooms: 5,
    bathrooms: 4,
    featured: true,
    furnishing: "Unfurnished",
    floor: "Ground + 2",
    facing: "West",
    parking: "3 Open",
    possession: "Ready to Move",
    description: "A standalone Pashan bungalow with independent access on all sides, close to the hills and Pune's premium school belt.",
    amenities: ["Private Garden", "Terrace", "Servant Quarters", "Borewell", "Security Cabin", "Ample Parking"],
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1540518614846-7eded433c457?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 13,
    title: "IT Park Office Space",
    location: "Magarpatta, Pune",
    price: "₹2.9 Cr",
    area: "2200 sqft",
    type: "Sale",
    bedrooms: 0,
    bathrooms: 3,
    furnishing: "Bare Shell",
    floor: "6th of 12",
    facing: "South",
    parking: "5 Covered",
    possession: "Ready to Move",
    description: "A ready commercial floor inside Magarpatta's integrated township, with round-the-clock access and strong connectivity.",
    amenities: ["Central AC", "High-Speed Lifts", "Cafeteria", "24x7 Security", "Power Backup", "Conference Facility"],
    image: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600121848594-d8644e57abab?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1592229505726-ca121723b8ef?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 14,
    title: "Luxury 4BHK with Garden View",
    location: "Koregaon Park, Pune",
    price: "₹6.5 Cr",
    area: "2500 sqft",
    type: "Sale",
    bedrooms: 4,
    bathrooms: 4,
    featured: true,
    furnishing: "Semi-Furnished",
    floor: "16th of 20",
    facing: "West",
    parking: "2 Covered",
    possession: "Ready to Move",
    description: "An address in Koregaon Park with unobstructed garden views from every room and premium finishes throughout.",
    amenities: ["Garden View", "Clubhouse", "Infinity Pool", "Gym", "Concierge", "Valet Parking"],
    image: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1567016432779-094069958ea5?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615873968403-89e068629265?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 15,
    title: "Premium Office Floor",
    location: "Hinjewadi, Pune",
    price: "₹5.8 Cr",
    area: "3200 sqft",
    type: "Sale",
    bedrooms: 0,
    bathrooms: 4,
    furnishing: "Bare Shell",
    floor: "14th of 30",
    facing: "East",
    parking: "8 Covered",
    possession: "Ready to Move",
    description: "A full commercial floor in a Hinjewadi landmark tower, built for a headquarters presence with skyline views on three sides.",
    amenities: ["Central AC", "High-Speed Lifts", "24x7 Security", "Cafeteria", "Conference Facility", "Power Backup"],
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600121848594-d8644e57abab?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1592229505726-ca121723b8ef?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 16,
    title: "Luxury Studio Apartment",
    location: "Koregaon Park, Pune",
    price: "₹42,000/mo",
    area: "720 sqft",
    type: "Rent",
    bedrooms: 1,
    bathrooms: 1,
    furnishing: "Fully Furnished",
    floor: "3rd of 10",
    facing: "North",
    parking: "1 Open",
    possession: "Immediate",
    description: "A tastefully finished studio in Koregaon Park with designer fittings, ideal for a young professional wanting a low-maintenance base.",
    amenities: ["Designer Interiors", "Modular Kitchen", "Lift", "24x7 Security", "Wi-Fi Ready", "Near Metro"],
    image: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1631889993959-41b4e9c6e3c5?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 17,
    title: "3BHK Smart Home",
    location: "Hinjewadi, Pune",
    price: "₹1.65 Cr",
    area: "1650 sqft",
    type: "Sale",
    bedrooms: 3,
    bathrooms: 3,
    furnishing: "Semi-Furnished",
    floor: "8th of 11",
    facing: "East",
    parking: "1 Covered",
    possession: "Ready to Move",
    description: "A smart-enabled 3BHK in Hinjewadi with app-controlled lighting and security, in one of Pune's fastest-growing tech hubs.",
    amenities: ["Home Automation", "Gym", "Garden", "24x7 Security", "Power Backup", "Lift"],
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 18,
    title: "Premium 2BHK Apartment",
    location: "Aundh, Pune",
    price: "₹85 Lakh",
    area: "1100 sqft",
    type: "Sale",
    bedrooms: 2,
    bathrooms: 2,
    furnishing: "Fully Furnished",
    floor: "6th of 14",
    facing: "South",
    parking: "1 Covered",
    possession: "Ready to Move",
    description: "A premium 2BHK in Aundh with modern interiors, close to IT parks, schools, and shopping centers.",
    amenities: ["Swimming Pool", "Gym", "Clubhouse", "24x7 Security", "Garden", "Power Backup"],
    image: "https://images.unsplash.com/photo-1600047509782-20d39509f26d?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600047509782-20d39509f26d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1540518614846-7eded433c457?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 19,
    title: "Commercial Showroom",
    location: "Camp, Pune",
    price: "₹2.1 Cr",
    area: "1450 sqft",
    type: "Sale",
    bedrooms: 0,
    bathrooms: 2,
    furnishing: "Bare Shell",
    floor: "Ground",
    facing: "Main Road",
    parking: "2 Open",
    possession: "Ready to Move",
    description: "A high-visibility ground-floor showroom on Camp's busiest commercial stretch, with wide frontage and high footfall.",
    amenities: ["Main Road Frontage", "High Footfall", "Power Backup", "Security", "Wide Frontage", "Loading Access"],
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600121848594-d8644e57abab?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1560185007-cde436f6a4d0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1592229505726-ca121723b8ef?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 20,
    title: "Affordable 2BHK Flat",
    location: "Bibwewadi, Pune",
    price: "₹24,000/mo",
    area: "950 sqft",
    type: "Rent",
    bedrooms: 2,
    bathrooms: 2,
    furnishing: "Semi-Furnished",
    floor: "2nd of 6",
    facing: "West",
    parking: "1 Open",
    possession: "Immediate",
    description: "A comfortable, budget-friendly 2BHK in a quiet residential pocket of Bibwewadi, close to schools and local markets.",
    amenities: ["Lift", "24x7 Water Supply", "Security", "Parking", "Near Schools", "Power Backup"],
    image: "https://images.unsplash.com/photo-1502672023488-70e25813eb80?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1502672023488-70e25813eb80?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615529182904-14819c35db37?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 21,
    title: "Luxury Villa with Pool",
    location: "Wakad, Pune",
    price: "₹5.5 Cr",
    area: "4500 sqft",
    type: "Sale",
    bedrooms: 5,
    bathrooms: 5,
    featured: true,
    furnishing: "Fully Furnished",
    floor: "Ground + 2",
    facing: "North",
    parking: "4 Covered",
    possession: "Ready to Move",
    description: "A statement villa in Wakad with a private pool and landscaped courtyard — turnkey and fully furnished for immediate living.",
    amenities: ["Private Pool", "Landscaped Garden", "Home Theatre", "Servant Quarters", "Security Cabin", "Smart Locks"],
    image: "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1540518614846-7eded433c457?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1631889992043-c9b829fc8b0c?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 22,
    title: "Ready-to-Move 3BHK",
    location: "Viman Nagar, Pune",
    price: "₹1.6 Cr",
    area: "1450 sqft",
    type: "Sale",
    bedrooms: 3,
    bathrooms: 3,
    furnishing: "Semi-Furnished",
    floor: "9th of 16",
    facing: "East",
    parking: "2 Covered",
    possession: "Ready to Move",
    description: "A well-connected 3BHK near Viman Nagar's airport road, with a bright layout and access to the city's best schools.",
    amenities: ["Clubhouse", "Swimming Pool", "Gym", "24x7 Security", "Power Backup", "Kids Play Area"],
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1523217582562-09d0def993a6?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1620626011761-996317b8d101?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 23,
    title: "Lake View Apartment",
    location: "Pimple Nilakh, Pune",
    price: "₹2.5 Cr",
    area: "1750 sqft",
    type: "Sale",
    bedrooms: 3,
    bathrooms: 3,
    furnishing: "Semi-Furnished",
    floor: "11th of 19",
    facing: "North",
    parking: "2 Covered",
    possession: "Ready to Move",
    description: "A calm, lake-facing 3BHK in Pimple Nilakh with floor-to-ceiling windows framing the water on two sides.",
    amenities: ["Lake View", "Clubhouse", "Gym", "24x7 Security", "Power Backup", "Jogging Track"],
    image: "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1615874959474-d609969a20ed?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=1200&h=800&fit=crop",
    ]
  },
  {
    id: 24,
    title: "Premium Duplex House",
    location: "Koregaon Park, Pune",
    price: "₹3.95 Cr",
    area: "2700 sqft",
    type: "Sale",
    bedrooms: 4,
    bathrooms: 4,
    furnishing: "Semi-Furnished",
    floor: "Duplex (G+1)",
    facing: "South",
    parking: "2 Covered",
    possession: "Ready to Move",
    description: "A duplex home in Pune's most prestigious address, Koregaon Park, with independent upper and lower living zones.",
    amenities: ["Duplex Layout", "Private Terrace", "Servant Quarters", "24x7 Security", "Power Backup", "Ample Parking"],
    image: "https://images.unsplash.com/photo-1600047509782-20d39509f26d?w=800&h=600&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1600047509782-20d39509f26d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1540518614846-7eded433c457?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=1200&h=800&fit=crop",
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=1200&h=800&fit=crop",
    ]
  }
];

export const agreements = [
  { id: 1, title: "Leave & License Agreement", description: "Standard rental agreement for residential properties", price: "₹2,500+" },
  { id: 2, title: "Sale Deed Drafting", description: "Legal document for property sale transactions", price: "₹5,000+" },
  { id: 3, title: "Property Lease Deed", description: "Long-term commercial & residential lease", price: "₹3,500+" },
  { id: 4, title: "Development Agreement", description: "For builder & landowner partnerships", price: "Custom" }
];

export const documents = [
  { id: 1, title: "Sale Deed / Title Deed", description: "Proof of ownership transfer", icon: "📄" },
  { id: 2, title: "Encumbrance Certificate", description: "Shows legal dues on property", icon: "🔒" },
  { id: 3, title: "Property Tax Receipts", description: "Tax payment records", icon: "💰" },
  { id: 4, title: "Building Approval Plan", description: "Municipal approval documents", icon: "🏗️" },
  { id: 5, title: "Possession Certificate", description: "Proof of possession", icon: "🗝️" },
  { id: 6, title: "Allotment Letter", description: "For society/flat allotment", icon: "📋" }
];